import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const submitLocationTransferReducer = (state = "", action) => {
  const actionName = serverApis.submitLocationTransfer.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return {
        message:action.json.result,
        screen:action.referenceObject
      }

    case getResetAction(actionName):
      return "";
    default:
      return state;
  }
};
